
import { memo } from "react";

export const About = () => {
	console.log('描写');
	console.log('アバウトです');

    return (
        <section >

			アバウトページです<br/>
			アバウトページです<br/>
			アバウトページです<br/>
			アバウトページです<br/>
			アバウトページです
			アバウトページです
			アバウトページです

            アバウトページです

        </section>
    )

}